import * as React from 'react';

import { Tab } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import {
  $currentFacilityGroup,
  $locationGroupTab,
} from '../../_state/locations.state';
import { useSettingsLocation } from '../../_state/settingsModule.state';
import { SettingsSubmodule } from '../_layouts/SettingsSubmodule';

import { LocationGroupInfo } from './LocationGroupInfo';

export const LocationGroupDetailsView = () => {
  const [, setLocation] = useSettingsLocation();
  const [locationGroupTab, setLocationGroupTab] = useAtom($locationGroupTab);
  const currentFacilityGroup = useAtomValue($currentFacilityGroup);

  const facilityCount = currentFacilityGroup?.data?.facilities?.length ?? 0;

  React.useEffect(() => () => setLocationGroupTab('group-info'), []);

  return (
    <SettingsSubmodule
      className={'@LocationGroupDetailsView h-full'}
      contentClassName="p-0"
      title={currentFacilityGroup?.data?.name ?? 'Loading...'}
      subtitle={
        facilityCount > 0
          ? `${facilityCount} ${facilityCount === 1 ? 'Facility' : 'Facilities'}`
          : '...'
      }
      onBackPressed={() => setLocation('/locations/groups')}
      tabs={
        <>
          <Tab
            selected={locationGroupTab === 'group-info'}
            onClick={() => setLocationGroupTab('group-info')}
          >
            Group Info
          </Tab>
          {/* <Tab
            selected={locationGroupTab === 'preferences'}
            onClick={() => setLocationGroupTab('preferences')}
          >
            Preferences
          </Tab>
          <Tab
            selected={locationGroupTab === 'document-templates'}
            onClick={() => setLocationGroupTab('document-templates')}
          >
            Document Templates
          </Tab> */}
        </>
      }
    >
      {locationGroupTab === 'group-info' && <LocationGroupInfo />}
      {/* {locationGroupTab === 'preferences' && <LocationGroupPreferences />}
      {locationGroupTab === 'document-templates' && (
        <LocationGroupDocumentTemplates />
      )} */}
    </SettingsSubmodule>
  );
};
